/* tslint:disable */
/* eslint-disable */
/**
 * Viewup Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetRegisterPathDataDto
 */
export interface GetRegisterPathDataDto {
    /**
     * 유저 uuid
     * @type {string}
     * @memberof GetRegisterPathDataDto
     */
    'userUuid': string;
    /**
     * 아이디
     * @type {string}
     * @memberof GetRegisterPathDataDto
     */
    'id': string;
    /**
     * 이름
     * @type {string}
     * @memberof GetRegisterPathDataDto
     */
    'name': string;
    /**
     * 회원가입 경로
     * @type {string}
     * @memberof GetRegisterPathDataDto
     */
    'registerPath': GetRegisterPathDataDtoRegisterPathEnum;
}

export const GetRegisterPathDataDtoRegisterPathEnum = {
    FriendlyRecommend: 'friendlyRecommend',
    Search: 'search',
    Naver: 'naver',
    Youtube: 'youtube',
    Instagram: 'instagram',
    Facebook: 'facebook',
    Other: 'other'
} as const;

export type GetRegisterPathDataDtoRegisterPathEnum = typeof GetRegisterPathDataDtoRegisterPathEnum[keyof typeof GetRegisterPathDataDtoRegisterPathEnum];


